if (window.location.hostname === 'app.honeycrm.com') {
    window.location.hostname = 'app.glasshive.com';
}
else if (window.location.hostname === 'partnerprogram.connectwise.com' || window.location.hostname === 'channelprogram.connectwise.com') {
    window.location.href = 'https://app.glasshive.com/PartnerProgram/Connectwise';
}

import './assets/css/themes/primitives.css';
import './assets/css/themes/theme-light.css';
import './assets/css/themes/theme-dark.css';

import Vue from 'vue';
import VueMask from 'v-mask'
import App from './App.vue';
import { router } from './router.js';
import store from './stores/index.js';
import VueHighcharts from 'highcharts-vue';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import SolidGauge from 'highcharts/modules/solid-gauge';
import { helpers } from './scripts/helpers';
import { api } from './scripts/api';
import Directives from './scripts/directives';
import Vuelidate from 'vuelidate';
import bootbox from 'bootbox';
import moment from 'moment';
import tz from 'moment-timezone/builds/moment-timezone-with-data';
import _ from 'lodash';
import VueFroala from 'vue-froala-wysiwyg';
import VueI18n from 'vue-i18n'
import { locales } from './locales/locales';
import VueResize from 'vue-resize';
import VueAnalytics from 'vue-analytics';
import VueGtm from 'vue-gtm';
import vmodal from 'vue-js-modal';
import VTooltip from 'v-tooltip';
import LottieVuePlayer from '@lottiefiles/vue-lottie-player';
import VueTour from 'vue-tour'

import MasterTableRow from './components/master-table/master-table-row.vue';
import MasterTableCell from './components/master-table/master-table-cell.vue';
import MasterTableRowOptions from './components/master-table/master-table-row-options.vue';
import 'vue-resize/dist/vue-resize.css';
import vuetify from './plugins/vuetify'
import {VueMasonryPlugin} from 'vue-masonry';
import initSentry from "@/scripts/sentry";

require('jquery-ui');
require('rangeslider.js/dist/rangeslider.min');
require('froala-editor/js/froala_editor.pkgd.min');
require('froala-editor/css/froala_editor.pkgd.min.css');
require('font-awesome/css/font-awesome.css');
require('froala-editor/css/froala_style.min.css');
require('vue-multiselect/dist/vue-multiselect.min.css');
require('@/scripts/colorpicker');

Highcharts.setOptions({
    lang: {
        thousandsSep: ','
    }
});

if (typeof Highcharts === 'object') {
    HighchartsMore(Highcharts);
    SolidGauge(Highcharts);
};

window.Intercom('boot', {
    app_id: APP_ID,
    custom_launcher_selector: '#intercom'
});

Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(VueHighcharts , { Highcharts });
Vue.use(VueFroala);
Vue.use(VueI18n);
Vue.use(VueResize);
Vue.use(VueMasonryPlugin);
Vue.use(LottieVuePlayer);
Vue.use(VueTour)

Vue.use(VTooltip, {
    defaultHtml: false,
});
Vue.use(VueGtm, {
    id: "GTM-PN9WWQQ",
    defer: false,
    enabled: true,
    trackOnNextTick: false,
});
Vue.use(VueAnalytics, {
    id: 'UA-139697157-1',
    router
});
Vue.use(vmodal, { dynamic: true });

const i18n = new VueI18n({
    locale: 'en',
    messages: locales,
});

Vue.prototype.$bootbox = bootbox;
Vue.prototype.$helpers = helpers;
Vue.prototype.$api = api;
Vue.prototype.$moment = moment;
Vue.prototype.$_ = _;

Vue.config.productionTip = false;

Vue.component(MasterTableRow.name, MasterTableRow);
Vue.component(MasterTableCell.name, MasterTableCell);
Vue.component(MasterTableRowOptions.name, MasterTableRowOptions);

initSentry();

new Vue({
    store,
    router,
    i18n,
    vuetify,
    render: h => h(App)
}).$mount('#app');
